<template>
  <div style="overflow-x: auto;max-height:600px;">
    <div v-if="fina_data.financeList.length==0">
      <div v-if="havedata" style="text-align:center">暂无数据</div>
      <Col v-else class="demo-spin-col">
        <Spin fix>加载中...</Spin>
      </Col>
    </div>
    <div v-else>
      <table cellspacing="0" cellpadding="0" border="1" style="border-collapse:collapse;border: 1px solid rgb(233, 234, 236);width: max-content;margin-bottom: 10px">
        <tr style="line-height:35px;font-size: 15px;width: 1200px;text-align: center">
          <td v-for="(item,index) in title" :style="{width: item.width}" style="padding: 0 5px">{{item.name}}</td>
        </tr>
        <template v-for="(item,index) in fina_data.financeList" style="line-height: 20px; font-size:12px;">
          <tr v-for="(company,c_index) in item.enroll" class="detail_mess">
            <td :style="{width: title[0].width}" v-if="c_index==0" :rowspan="item.enroll.length">包组{{item.groupNo}}：{{item.groupName}}</td>
            <td :style="{width: title[1].width}">{{company.companyName}}</td>
            <td :style="{width: title[2].width}" style="text-align:center">
              <div v-if="company.status==3" style="color: rgb(25, 190, 107);">成功</div>
              <div v-else style="color: rgb(255, 153, 0);">未成功</div>
            </td>
            <td style="text-align:center">
              <div
                v-if="company.status==3"
                style="color: rgb(25, 190, 107);"
              >{{company.ordersDto.orderAmountTotal|toMoney}}</div>
            </td>
            <td style="text-align:center">
              <div v-if="company.status==3">{{company.ordersDto.payTime|filterTime}}</div>
            </td>
            <td style="text-align:center">
              <div
                v-if="company.status==3&&company.ordersDto.orderStatus==3"
                style="color: rgb(25, 190, 107);"
              >已开票</div>
              <div
                v-if="company.status==3&&company.ordersDto.orderStatus!=3"
                style="color: rgb(255, 153, 0);"
              >未开票</div>
            </td>
            <td style="text-align:center">
              <div
                v-if="item.marginAmount>=0"
                style="color: rgb(25, 190, 107);"
              >{{item.marginAmount|toMoney}}</div>
            </td>
            <!-- 保证金详情 -->
            <td style="text-align:center;padding: 0px 10px;" class="margin">
              <div v-if="company.openId === '是'">
                <div style="color: rgb(25, 190, 107);">电子保函</div>
              </div>
              <div v-else>
                <div
                  v-if="company.status1.status==0&&company.status2.status==0&&company.status3.status==0"
                  style="color: rgb(255, 153, 0)"
                >未领取</div>
                <!-- <div v-if="company.status1.status==1" style="text-align:left">
                  <div>
                    领取金额：
                    <span style="color: rgb(25, 190, 107);">{{company.status1.money[index]|toMoney}}</span>
                  </div>
                  <div>领取时间：{{company.status1.time|filterTime}}</div>
                </div> -->
                <div v-if="company.status1.status==1" style="text-align:left;display: inline-block;" :class="{'extrabd': index>0}" v-for="(item,index) in company.status1.money">
                  <div>
                    领取金额：
                    <span style="color: rgb(25, 190, 107);">{{company.status1.money[index]|toMoney}}</span>
                  </div>
                  <div>领取时间：{{company.status1.time[index]|filterTime}}</div>
                </div>
                <div v-if="company.status3.status==1" style="text-align:left;display: inline-block;" v-for="(item,index) in company.status3.money">
                  <div>
                    领取金额：
                    <span
                      style="color: rgb(25, 190, 107);"
                    >{{company.status3.money[index]|toMoney}}</span>
                    <span style="color: rgb(237, 64, 20);">（已退）</span>
                  </div>
                  <div>领取时间：{{company.status3.time[index]|filterTime}}</div>
                </div>
                <div v-if="company.status2.status==1" style="text-align:left;display: inline-block;border-left:1px solid rgb(233, 234, 236);padding-left: 5px" v-for="(item,index) in company.status2.money">
                  <div>
                    退保金额：
                    <span
                      style="color: rgb(237, 64, 20);"
                    >{{company.status2.money[index]|toMoney}}</span>
                  </div>
                  <div>退保时间：{{company.status2.time[index]|filterTime}}</div>
                </div>
              </div>
            </td>
            <!-- 应收服务费 -->
            <!-- <td style="text-align:center">
              <div
                v-if="item.groupReceivable>=0"
                style="color: rgb(25, 190, 107);"
              >{{item.groupReceivable|toMoney}}</div>
            </td> -->
            <td style="text-align:center" v-for="recive in company.abpEnrollExt" v-if="recive.groupId==item.id">
              <div
                style="color: rgb(25, 190, 107);"
              >{{recive.receivable|toMoney}}</div>
            </td>
            <!-- 收取金额 -->
            <td style="text-align:center">
              <div
                v-if="company.service_date"
                style="color: rgb(25, 190, 107);"
              >{{company.service_charge|toMoney}}</div>
              <div v-else style="color: rgb(255, 153, 0);">未收取</div>
            </td>
            <!-- 收取时间 -->
            <td style="text-align:center">
              <div v-if="company.service_date">{{company.service_date|filterTime}}</div>
            </td>
            <!-- 合同 -->
            <td style="text-align:left" class="margin">
              <div v-if="company.ispact">
                合同编号：
                {{company.pactNo}}
              </div>
              <div v-if="company.ispact">存档日期：{{company.pactTime|filterTime}}</div>
              <div v-if="company.hasSigningTime">签订日期：{{company.pactSigningTime|filterTime}}</div>
              <div v-else>签订日期：无签订日期</div>
            </td>
          </tr>
        </template>
      </table>
      <h3 v-if="buyer_pay.length>0" style="margin-bottom: 10px">采购人付款：</h3>
      <table v-if="buyer_pay.length>0" cellspacing="0" cellpadding="0" border="1" style="border-collapse:collapse;border: 1px solid rgb(233, 234, 236);width: max-content;margin-bottom: 10px">
        <tr style="line-height:35px;font-size: 15px;width: 1200px;text-align: center">
          <td v-for="(item,index) in buyer_tit" :style="{width: item.width}" style="padding: 0 5px">{{item.name}}</td>
        </tr>
        <tr v-for="item in buyer_pay" class="detail_mess" style="line-height: 20px">
          <td style="text-align:left">{{item.abpServiceCharge.companyName}}</td>
          <td style="text-align:center;color: rgb(25, 190, 107)">{{item.orderAmountTotal|toMoney}}</td>
          <td style="text-align:center">{{item.payTime|filterTime}}</td>
        </tr>
      </table>
      <Button type="info" @click="send" v-if="sensAble">发送可开标提醒</Button>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/lib/tool";
import requestUrls from "@/lib/requestUrls";
import ajax from "@/lib/ajax";
import sendMessage from '@/lib/message'

export default {
  props: {
    projectData: {
      default: () => {
        return {};
      }
    },
    agreement: Array
  },
  data() {
    return {
      title: [
        { name: "包组", width: "120px" },
        { name: "单位", width: "250px" },
        { name: "报名状态", width: "80px" },
        { name: "标书款", width: "70px" },
        { name: "售卖时间", width: "90px" },
        { name: "发票", width: "60px" },
        { name: "应收保证金", width: "90px" },
        { name: "保证金详情", width: "" },
        { name: "应收服务费", width: "90px" },
        { name: "收取金额", width: "90px" },
        { name: "收取时间", width: "90px" },
        { name: "合同", width: "" }
      ],
      buyer_tit: [
        { name: "采购人", width: "250px" },
        { name: "服务费收取金额", width: "120px" },
        { name: "收取时间", width: "120px" }
      ],
      buyer_pay: [],
      fina_data: { financeList: [] },
      havedata: 0 //判断是否有数据
    };
  },
  computed: {
    sensAble () {
      return this.projectData.projectProperty === '政府采购' && this.agreement.length && this.agreement[0].ifKnow === '可以获悉'
    }
  },
  methods: {
    margin_get(data) {
      let ordersDto = {
        orderAmountTotal: '',
        payTime: '',
        orderStatus: ''
      };
      for (let i = 0; i < data.financeList.length; i++) {
        for (let j = 0; j < data.financeList[i].enroll.length; j++) {
          if(!data.financeList[i].enroll[j].ordersDto){
            data.financeList[i].enroll[j].ordersDto = ordersDto
          }
          let name = data.financeList[i].enroll[j].companyName;
          data.financeList[i].enroll[j] = {
            ...data.financeList[i].enroll[j],
            status1: { status: 0, money: [], time: [] },
            status2: { status: 0, money: [], time: [] },
            status3: { status: 0, money: [], time: [] }
          };
          for (let k = 0; k < data.financeList[i].margin.length; k++) {
            if (
              name == data.financeList[i].margin[k].ghfCompanyName &&
              data.financeList[i].enroll[j].status == 3
            ) {
              if (data.financeList[i].margin[k].orderStatus == 2) {
                data.financeList[i].enroll[j].status1 = {
                  status: 1,
                  money: [
                    ...data.financeList[i].enroll[j].status1.money,
                    data.financeList[i].margin[k].orderAmountTotal
                  ],
                  time: [
                    ...data.financeList[i].enroll[j].status1.time,
                    data.financeList[i].margin[k].payTime
                    ]
                }; //status1 已领取
              } else if (data.financeList[i].margin[k].orderStatus == 0) {
                data.financeList[i].enroll[j].status2 = {
                  status: 1,
                  money: [
                    ...data.financeList[i].enroll[j].status2.money,
                    data.financeList[i].margin[k].orderAmountTotal
                  ],
                  time: [
                    ...data.financeList[i].enroll[j].status2.time,
                    data.financeList[i].margin[k].payTime
                  ]
                }; //status2已退
              } else if (data.financeList[i].margin[k].orderStatus == 4) {
                data.financeList[i].enroll[j].status3 = {
                  status: 1,
                  money: [
                    ...data.financeList[i].enroll[j].status3.money,
                    data.financeList[i].margin[k].orderAmountTotal
                  ],
                  time: [
                    ...data.financeList[i].enroll[j].status3.time,
                    data.financeList[i].margin[k].payTime
                  ]
                }; //status3 领取后退
              }
            }
          }
        }
      }
      return data;
    },
    service_get(data) {
      var self = this;
      for (let i = 0; i < data.financeList.length; i++) {
        for (let j = 0; j < data.financeList[i].enroll.length; j++) {
          let name = data.financeList[i].enroll[j].companyName;
          let group_id = data.financeList[i].id;
          data.financeList[i].enroll[j] = {
            ...data.financeList[i].enroll[j],
            service_charge: 0,
            service_date: "",
            order_No: "", //比较大小获取最新日期
            pactNo: "", //合同编号
            pactTime: "", //存档日期
            pactSigningTime: "", //签订日期
            ispact: false,
            hasSigningTime: false
          };
          for (let k = 0; k < data.serviceCharge.length; k++) {
            if (data.serviceCharge[k].abpServiceCharge.isBuyer) {
              // if (i == 0 && j == 0) {
              //   self.buyer_pay = [...self.buyer_pay, data.serviceCharge[k]];
              // }
            } else if (
              name == data.serviceCharge[k].ghfCompanyName &&
              group_id == data.serviceCharge[k].abpServiceCharge.groupId
            ) {
              // let sum = data.financeList[i].enroll[j].service_charge + data.serviceCharge[k].orderAmountTotal
              // self.$set(data.financeList[i].enroll[j],'service_charge',sum)
              data.financeList[i].enroll[j].service_charge =
                data.financeList[i].enroll[j].service_charge +
                data.serviceCharge[k].orderAmountTotal;
              if (data.financeList[i].enroll[j].service_date) {
                if (
                  data.serviceCharge[k].orderNo >
                  data.financeList[i].enroll[j].order_No
                ) {
                  // self.$set(data.financeList[i].enroll[j],'order_No',data.serviceCharge[k].orderNo)
                  // self.$set(data.financeList[i].enroll[j],'service_date',data.serviceCharge[k].payTime)
                  data.financeList[i].enroll[j].order_No =
                    data.serviceCharge[k].orderNo;
                  data.financeList[i].enroll[j].service_date =
                    data.serviceCharge[k].payTime;
                  data.financeList[i].enroll[j].pactNo =
                    data.serviceCharge[k].abpServiceCharge.pactNo;
                  data.financeList[i].enroll[j].pactTime =
                    data.serviceCharge[k].abpServiceCharge.pactTime;
                  data.financeList[i].enroll[j].pactSigningTime =
                    data.serviceCharge[k].abpServiceCharge.pactSigningTime;
                  data.financeList[i].enroll[j].hasSigningTime =
                    data.serviceCharge[k].abpServiceCharge.hasSigningTime;
                }
              } else {
                // self.$set(data.financeList[i].enroll[j],'order_No',data.serviceCharge[k].orderNo)
                //   self.$set(data.financeList[i].enroll[j],'service_date',data.serviceCharge[k].payTime)
                data.financeList[i].enroll[j].order_No =
                  data.serviceCharge[k].orderNo;
                data.financeList[i].enroll[j].service_date =
                  data.serviceCharge[k].payTime;
                data.financeList[i].enroll[j].ispact = true;
                data.financeList[i].enroll[j].pactNo =
                  data.serviceCharge[k].abpServiceCharge.pactNo;
                data.financeList[i].enroll[j].pactTime =
                  data.serviceCharge[k].abpServiceCharge.pactTime;
                data.financeList[i].enroll[j].pactSigningTime =
                  data.serviceCharge[k].abpServiceCharge.pactSigningTime;
                data.financeList[i].enroll[j].hasSigningTime =
                  data.serviceCharge[k].abpServiceCharge.hasSigningTime;
              }
            }
          }
        }
      }
      data.serviceCharge.forEach(item => {
        if (item.abpServiceCharge.isBuyer) {
          self.buyer_pay = [...self.buyer_pay, item]
        }
      })
      return data;
    },
    sortGroup(data) {
      let group = data.financeList
      let groupInOrder = []
      group.forEach(item => {
        let index = parseInt(item.groupNo) - 1
        groupInOrder[index] = item
      })
      let groupOrderResult = []
      // 去除空数据并记录第一个空的位置
      for (let i = 0; i < groupInOrder.length; i++) {
        let item = groupInOrder[i]
        if (item) {
          groupOrderResult.push(item)
        }
      }
      data.financeList = groupOrderResult
      return data
    },
    send () {
      // 委托协议
      this.$Modal.confirm({
        title: '发送提醒',
        content: '确定发送短信通知采购人进行开标吗？',
        onOk: async () => {
          let typeParams = {
            phone: this.agreement[0].partyAContactNumber,
            content: `尊敬的${this.projectData.purchaserName}-${this.agreement[0].partyAContact}：您好！ 您的${this.projectData.projectName}项目响应供应商数量符合要求，将于${this.projectData.clMeetingRoom.beginTime}进行开评标，请知悉！`
          }
          await sendMessage('phoneContent', typeParams)
        }
      })
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return "";
      }
      return val.split("T")[0];
    },
    toMoney(num) {
      if (!num) {
        return "￥ 0";
      }
      if (num) {
        if (isNaN(num)) {
          alert("金额中含有不能识别的字符");
          return;
        }
        num = typeof num == "string" ? parseFloat(num) : num; //判断是否是字符串如果是字符串转成数字
        num = num.toFixed(2); //保留两位
        num = parseFloat(num); //转成数字
        num = num.toLocaleString(); //转成金额显示模式
        //判断是否有小数
        if (num.indexOf(".") == -1) {
          num = "￥" + num + ".00";
        } else {
          num = num.split(".")[1].length < 2 ? "￥" + num + "0" : "￥" + num;
        }
        return num; //返回的是字符串23,245.12保留2位小数
      } else {
        return (num = null);
      }
    }
  },
  watch: {
    async projectData(val) {
      this.fina_data = { financeList: [] }
      this.buyer_pay = []
      this.havedata = 0
      let fina_data = await ajax.get(
        "/api/services/app/ClGroupDb/GetProjectCharge?projectId=" + val.id
      )
      this.fina_data = fina_data.data.result
      // this.fina_data.financeList.forEach(group=>{
      //   group.enroll = group.enroll.filter(bid=>{
      //     return bid.status == '3'
      //   })
      // })
      this.fina_data = this.sortGroup(this.fina_data)
      this.fina_data = this.margin_get(this.fina_data)
      this.fina_data = this.service_get(this.fina_data)
      this.havedata = 1
      this.fina_data.financeList.forEach(Gro=>{
        Gro.enroll = Gro.enroll.filter(company=>{
          return company.projectId == Gro.projectId
        })
      })
    }
  }
};
</script>

<style lang="less" scoped>
.detail_mess > td {
  box-sizing: border-box;
  padding: 5px 10px;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.margin div {
  padding: 3px 0;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.extrabd {
  border-left:1px solid rgb(233, 234, 236);
  padding-left: 5px!important;
  margin-left: 5px!important
}
</style>